(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen/assets/javascripts/banners.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen/assets/javascripts/banners.js');

'use strict';

const _excluded = ["classNames", "lottoDraws", "wager"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const {
  utils
} = svs.numbergames.andra_chansen;

const createBanner = (template, data) => svs.numbergames.andra_chansen_banners.createBanner(template, data);

const rowBanner = _ref => {
  var _utils$andraChansenDr;
  let {
      classNames = [],
      lottoDraws,
      wager
    } = _ref,
    options = _objectWithoutProperties(_ref, _excluded);
  const calcChances = (draws, wagerObj) => ({
    chances: utils.chancesPerWager(wagerObj),
    afterDromvinstenChances: utils.afterDromvinstenChances(draws, wagerObj),
    isSubscription: wagerObj.isSubscription
  });
  const {
    render,
    update
  } = svs.numbergames.andra_chansen_banners.rowBanner(_objectSpread(_objectSpread({}, calcChances(lottoDraws, wager)), {}, {
    endDate: (_utils$andraChansenDr = utils.andraChansenDraw()) === null || _utils$andraChansenDr === void 0 ? void 0 : _utils$andraChansenDr.endDate,
    classNames
  }, options));
  return {
    render,
    update: _ref2 => {
      let {
        lottoDraws,
        wager
      } = _ref2;
      return update(_objectSpread({}, calcChances(lottoDraws, wager)));
    }
  };
};

const infoBanner = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const draw = utils.afterDromvinstenDraw() || utils.andraChansenDraw();
  const isAfterDromvinsten = utils.isAfterDromvinsten(draw);
  const showBannerDateSmartness = utils.showBannerDateSmartness(utils.andraChansenDraw());
  return svs.numbergames.andra_chansen_banners.infoBanner({
    draw,
    isAfterDromvinsten,
    showBannerDateSmartness,
    options
  });
};


const noWinBanner = _ref3 => {
  let {
    lottoDraw,
    wager
  } = _ref3;
  const andraChansenDraw = utils.andraChansenDraw();
  const afterDromvinstenDraw = utils.afterDromvinstenDraw();
  return svs.numbergames.andra_chansen_banners.noWinBanner({
    andraChansenDraw,
    afterDromvinstenDraw,
    chancesPerLottoDraw: utils.chancesPerLottoDraw(wager),
    isInCurrentPeriod: utils.isInCurrentPeriod(andraChansenDraw, lottoDraw),
    isInCurrentAfterDromvinstenPeriod: utils.isInCurrentPeriod(afterDromvinstenDraw, lottoDraw),
    triggeredAfterDromvinsten: utils.triggeredAfterDromvinsten(lottoDraw)
  });
};


const peppBanner = _ref4 => {
  let {
    lottoDraw,
    options = {}
  } = _ref4;
  const afterDromvinstenDraw = utils.afterDromvinstenDraw();
  const triggeredAfterDromvinsten = utils.triggeredAfterDromvinsten(lottoDraw);
  const isInCurrentPeriod = utils.isInCurrentPeriod(afterDromvinstenDraw, lottoDraw);
  return svs.numbergames.andra_chansen_banners.peppBanner({
    afterDromvinstenDraw,
    triggeredAfterDromvinsten,
    isInCurrentPeriod,
    options
  });
};
svs.numbergames.andra_chansen.banners = {
  infoBanner,
  noWinBanner,
  peppBanner,
  rowBanner
};

 })(window);